import { render, staticRenderFns } from "./QA_en.vue?vue&type=template&id=cc6de050&scoped=true&"
import script from "./QA_en.vue?vue&type=script&lang=js&"
export * from "./QA_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6de050",
  null
  
)

export default component.exports